import { push } from 'react-router-redux';

import DB_CONST from '../../config/db_const';
import { SET_ROLE } from './reducer';

export const setUser = user => ({
  type: SET_ROLE,
  user,
});

export const redirectIfLoggedIn = () => (dispatch, getState) => {
  const { role } = getState().user;

  if (role === DB_CONST.USER_ROLES.PROVIDER) {
    return dispatch(push('/provider'));
  } else if (role === DB_CONST.USER_ROLES.CUSTOMER) {
    return dispatch(push('/customer/plans'));
  } else if (role === DB_CONST.USER_ROLES.ADMIN) {
    return dispatch(push('/admin'));
  }
  return false;
};

export const login = values => async dispatch => {
  const { token, role, firstName } = await fetch('/login', {
    method: 'post',
    body: values,
    credentials: 'include',
  });
  localStorage.setItem('token', token);

  await dispatch(setUser({ role, firstName }));
  return dispatch(redirectIfLoggedIn());
};

export const superLogin = values => async dispatch => {
  const { token, role, firstName } = await fetch('/admin/super-login', {
    method: 'post',
    body: values,
    credentials: 'include',
  });
  localStorage.setItem('token', token);

  await dispatch(setUser({ role, firstName }));
  return dispatch(redirectIfLoggedIn());
};

export const logOut = () => async dispatch => {
  localStorage.removeItem('token');
  await dispatch(
    setUser({
      role: DB_CONST.USER_ROLES.GUEST,
      firstName: null,
    }),
  );
  return dispatch(redirectIfLoggedIn());
};
